import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const GridComponent = ({ content }) => {
  const gridLength = content?.grid?.length < 4

  const gridData = content?.grid?.map((item, index) => {
    return (
      <GridItem key={index} gridlength={gridLength} icons={item?.icon}>
        {item?.icon && (
          <Icon src={item?.icon?.sourceUrl} alt={item?.icon?.altText} />
        )}
        <GridHeadline>{item?.gridHeadline}</GridHeadline>
        <Body>{item?.body}</Body>
      </GridItem>
    )
  })
  return (
    <Wrapper>
      <SectionHeader $small={content?.headerSmall}>
        {content?.sectionHeader}
      </SectionHeader>
      {content?.header && (
        <PurpleHeader>
          <Header>{content?.header}</Header>
        </PurpleHeader>
      )}
      <GridContent>{gridData}</GridContent>
      {content?.bottomCopy && (
        <BottomCopy dangerouslySetInnerHTML={{ __html: content?.bottomCopy }} />
      )}
    </Wrapper>
  )
}

export default GridComponent

const BottomCopy = styled.h5`
  ${text.h5};
  color: ${colors.black};
  padding: 2.778vw 0vw 1.389vw 0vw;

  ${media.fullWidth} {
    padding: 40px 0px 20px 0px;
  }

  ${media.tablet} {
    padding: 3.906vw 0vw 1.953vw 0vw;
  }

  ${media.mobile} {
    ${text.h4};
    padding: 9.346vw 0vw 4.673vw 0vw;
  }
`
const Body = styled.p`
  ${text.bodySm}
`
const GridHeadline = styled.p`
  ${text.bodyLgBold};
`
const Icon = styled.img`
  width: 5vw;
  height: 5vw;
  ${media.fullWidth} {
    width: 72px;
    height: 72px;
  }

  ${media.tablet} {
    width: 7.031vw;
    height: 7.031vw;
  }

  ${media.mobile} {
    width: 16.822vw;
    height: 16.822vw;
  }
`

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.black};
  gap: 1.597vw;
  counter-increment: item-counter;
  width: clamp(18.611vw, 18.611vw, 100%);
  margin: ${props => (props.gridlength ? "0 auto" : "unset")};

  &::before {
    content: counter(item-counter);
    ${text.stat};
    position: relative;
    display: ${props => (props.icons ? "none" : "flex")};
    align-items: center;
    justify-content: center;
    color: ${colors.white};
    background-color: ${colors.lightPurple};
    border-radius: 50%;
    border: 0.139vw solid ${colors.primaryPurple};
    width: 4.167vw;
    height: 4.167vw;
    margin: 0.417vw 0vw 2.014vw 0vw;
    left: 0.417vw;

    ${media.fullWidth} {
      border: 2px solid ${colors.primaryPurple};
      width: 60px;
      gap: 23px;
      height: 60px;
      margin: 6px 0px 29px 0px;
      left: 6px;
    }

    ${media.tablet} {
      border: 0.195vw solid ${colors.primaryPurple};
      width: 5.859vw;
      height: 5.859vw;
      gap: 2.246vw;
      margin: 0.586vw 0vw 2.832vw 0vw;
      left: 0.586vw;
    }

    ${media.mobile} {
      border: 0.467vw solid ${colors.primaryPurple};
      width: 14.019vw;
      height: 14.019vw;
      gap: 5.374vw;
      margin: 1.402vw 0vw 6.776vw 0vw;
      left: 1.402vw;
    }
  }

  ${media.fullWidth} {
    width: clamp(268px, 268px, 100%);
  }

  ${media.tablet} {
    width: clamp(21.289vw, 21.289vw, 100%);
  }

  ${media.mobile} {
    width: clamp(62.617vw, 62.617vw, 100%);
  }
`

const GridContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 1.667vw;

  ${media.fullWidth} {
    gap: 24px;
  }

  ${media.tablet} {
    gap: 2.344vw;
  }

  ${media.mobile} {
    gap: 5.607vw;
    flex-direction: column;
  }
`

const Header = styled.p`
  ${text.eyebrow};
  color: ${colors.white};
`
const PurpleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${colors.mediumPurple};
  padding: 1.111vw;
  margin-bottom: 1.667vw;
  border-radius: 0.278vw;
  ${media.fullWidth} {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
  }

  ${media.tablet} {
    padding: 1.563vw;
    border-radius: 0.391vw;
    margin-bottom: 2.344vw;
  }

  ${media.mobile} {
    padding: 3.738vw;
    border-radius: 0.935vw;
    margin-bottom: 5.607vw;
  }
`
const SectionHeader = styled.div`
  ${props => (props.$small ? `${text.h4}` : `${text.h3}`)};

  color: ${colors.black};
  margin: 1.389vw 0vw 0.694vw 0vw;
  ${media.fullWidth} {
    margin: 20px 0px 10px 0px;
  }

  ${media.tablet} {
    margin: 1.953vw 0vw 0.977vw 0vw;
  }

  ${media.mobile} {
    margin: 4.673vw 0vw 2.336vw 0vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 80vw;

  ${media.fullWidth} {
    width: 1152px;
  }

  ${media.tablet} {
    width: 92.188vw;
  }

  ${media.mobile} {
    width: 81.075vw;
  }
`
